import * as yup from 'yup';

export const BIRTH_DATE_FORMAT_REGEX = /^(0[1-9]|[12]\d|3[01])\.(0[1-9]|1[0-2])\.(19\d{2}|20\d{2})$/;

export const validateBirthDate = (value: string | undefined): boolean => {
  if (!value) return true;
  if (!BIRTH_DATE_FORMAT_REGEX.test(value)) return false;

  const [day, month, year] = value.split('.').map(Number);
  const date = new Date(year, month - 1, day);

  if (date.getDate() !== day || date.getMonth() !== month - 1 || date.getFullYear() !== year) {
    return false;
  }

  const now = new Date();
  if (date > now) return false;

  const oneHundredYearsAgo = new Date();
  oneHundredYearsAgo.setFullYear(now.getFullYear() - 100);
  if (date < oneHundredYearsAgo) return false;

  return true;
};

// Универсальная схема даты: только формат DD.MM.YYYY, без обязательности и бизнес-ограничений
export const dateSchema = yup.string().matches(BIRTH_DATE_FORMAT_REGEX, 'Дата должна быть в формате: число.месяц.год');

// Специализированная схема для даты рождения: на базе dateSchema + обязательность и ограничения по возрасту
export const birthDateSchema = dateSchema
  .required('Обязательное поле')
  .test('valid-birth-date', 'Введите корректную дату (не в будущем и не старше 100 лет)', validateBirthDate);

// Схема для ISO-дат (используется UDFormDateInput / react-datepicker, хранит toISOString())
export const isoDateSchema = yup
  .string()
  .test('valid-iso-date', 'Укажите корректную дату', (value) => !value || !isNaN(new Date(value).getTime()));
